export default "__VITE_ASSET__CGvg$gbn__"